<!-- CONTRACT: Present mode walks the same pages in this same order, listed by
     reportDocumentPages (services/report-document-pages.ts). A change to the
     order here is a change there too. -->
<main class="report-export" *ngIf="items.length > 0 && dateRange">
	<ng-container *ngFor="let item of items">
		<section class="report-export__slide">
			<app-report-preview-slide-host
				[item]="item"
				[brandId]="brandId"
				[dateRange]="dateRange!"
				[themeColor]="themeColor"
				[dataSource]="dataSource"
				[reportId]="reportId"
				(slideBuilt)="onSlideBuilt($event)"
			></app-report-preview-slide-host>
		</section>

		<!-- The pictures the reader put after this page, each a page of its
		     own, in the order the editor shows them. -->
		<section
			class="report-export__image"
			*ngFor="let image of picturesAfter.get(item.id) ?? []"
		>
			<app-report-image-figure
				[image]="image"
				[src]="imageSrc(image)"
				[aiLabel]="showsAiLabel(image)"
				caption="overlay"
			></app-report-image-figure>
		</section>

		<ng-container
			*ngTemplateOutlet="
				textPages;
				context: { $implicit: textPagesAfter[item.id] }
			"
		></ng-container>
		<ng-container
			*ngTemplateOutlet="
				chartPages;
				context: { $implicit: chartsAfter[item.id] }
			"
		></ng-container>
	</ng-container>

	<!-- The reader's own text placed nowhere on the page, after the fixed
	     sections and before the charts, as the preview shows it. -->
	<ng-container
		*ngTemplateOutlet="textPages; context: { $implicit: textPagesAtEnd }"
	></ng-container>

	<!-- The same text, laid out at a page's width and off the page, to be
	     measured for the packing above; gone once it has been. -->
	<div
		class="report-export__text-measure"
		#textMeasure
		*ngIf="textToMeasure.length"
	>
		<app-report-text-block
			*ngFor="let block of textToMeasure"
			[block]="block"
			[themeColor]="themeColor"
		></app-report-text-block>
	</div>

	<!-- The reader's own blocks placed nowhere on the page, in the order they
	     were added — the same order the preview shows them in. -->
	<ng-container
		*ngTemplateOutlet="chartPages; context: { $implicit: chartsAtEnd }"
	></ng-container>

	<!-- and the pictures placed nowhere else. -->
	<section class="report-export__image" *ngFor="let image of picturesAtEnd">
		<app-report-image-figure
			[image]="image"
			[src]="imageSrc(image)"
			[aiLabel]="showsAiLabel(image)"
			caption="overlay"
		></app-report-image-figure>
	</section>
</main>

<main class="report-export-error" *ngIf="!items.length && errorMessage">
	{{ errorMessage }}
</main>

<!-- Text is packed onto pages of its own, since a page of the PDF cannot
     stretch to fit what is on it. -->
<ng-template #textPages let-pages>
	<section class="report-export__text" *ngFor="let page of pages">
		<app-report-text-block
			*ngFor="let block of page"
			[block]="block"
			[themeColor]="themeColor"
		></app-report-text-block>
	</section>
</ng-template>

<ng-template #chartPages let-charts>
	<section class="report-export__block" *ngFor="let chart of charts">
		<app-custom-block-slide
			[block]="chart.block"
			[themeColor]="themeColor"
			[brandId]="brandId"
			[dateRange]="dateRange"
			[specEntities]="chart.spec?.entities"
			[dataSource]="dataSource"
			[home]="home"
		></app-custom-block-slide>
	</section>
</ng-template>
